<template>
  <div class="vm-black-list pointer" :class="browser_size" v-click-outside="close_more">
    <i class="afd afd-diandiandian" :class="browser_size != 'small' ?'black-5 gl-hover-text':'black-3'" @click.self="tab"></i>
    <div class="action-list" v-show="is_show_more">
        <a class="item-box black-8 nowrap flex-box flex-align-items-center fs14 gl-hover-text" @click="block">
            <span v-if="user.is_block == 0">{{$t('c.BlackList.text1')}}</span>
            <span v-if="user.is_block == 1">{{$t('c.BlackList.text2')}}</span>
        </a>
        <a v-if="is_creator" class="item-box black-8 nowrap flex-box flex-align-items-center fs14 gl-hover-text" @click="reject">
            <span v-if="user.is_reject == 0">{{$t('c.BlackList.text3')}}</span>
            <span v-if="user.is_reject == 1">{{$t('c.BlackList.text4')}}</span>
        </a>
        <a v-if="GL.ENV.is_huawei_apply || is_applying_google" class="item-box black-8 nowrap flex-box flex-align-items-center fs14 gl-hover-text" @click="jubao">
          {{$t('c.BlackList.text5')}}
        </a>
        <a v-else-if="is_this_user_creator" class="item-box black-8 nowrap flex-box flex-align-items-center fs14 gl-hover-text" @click="jubao">
          {{$t('c.BlackList.text5')}}
        </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { POST_API_USER_BLACK, POST_API_USER_UNBLACK } from '@/api/config';

export default {
  name: "black-list",
  props: {
    user: {
      default: {},
    },
  },
  data() {
    return {
        is_show_more:false,
    };
  },
  inject:['app_router_reload'],
  computed:{
    ...mapState('app', ['session_user', 'browser_size', 'is_applying_google']),
    is_creator() {
      if (
        this.session_user &&
        this.session_user.creator &&
        this.session_user.creator.status
      ) {
        return true;
      }
      return false;
    },
    is_this_user_creator() {
      if (
        this.user &&
        this.user.creator &&
        this.user.creator.status
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {},
  methods: {
    tab(){
        this.is_show_more = !this.is_show_more;
    },
    close_more(){
        this.is_show_more = false;
    },
    // jubao(){
    //     this.close_more();
    //     // this.$notify({
    //     //     title: '举报成功',
    //     //     group: 'success'
    //     // });
    //     this.$modal.show('dialog', {
    //         title: this.$t('c.dialog.text6'),
    //         buttons: [
    //         {
    //             title: this.$t('c.dialog.text1'),
    //             handler: () => {
    //             this.$modal.hide('dialog');
    //             },
    //         },
    //         {
    //             title: this.$t('c.dialog.text2'),
    //             handler: async () => {
    //               let text = `[${location.origin}/p/${this.params.post_id}] 你好，举报此创作者，理由为`;
    //               this.$modal.hide('dialog');
    //               this.$router.push(`/message/27f7cea2370d11e8ae8852540025c377?is_keyboard_up=1&text=${text}`);
    //             },
    //         },
    //         ],
    //     });
    // },
    jubao(){
      this.close_more();
      this.$modal.show(
          () => import("@/components/ModalItemList"),{
            param:{
              object_type:'user',
              object_id: this.user.user_id
            }
          },
          {
              pivotY: 0.5,
              classes: "v--modal-msg-order v--modal",
              height: "auto",
              width: 200,
              adaptive: false,
              scrollable: true,
          }
      );
    },
    jubao_old(){
        this.close_more();
        if(this.GL.ENV.is_huawei_apply || this.is_applying_google){
          this.$notify({
            title: '举报成功',
            group: 'success'
          });
          return false;
        }
      
        this.$modal.show('dialog', {
            title: this.$t('c.dialog.text6'),
            buttons: [
            {
                title: this.$t('c.dialog.text1'),
                handler: () => {
                this.$modal.hide('dialog');
                },
            },
            {
                title: this.$t('c.dialog.text2'),
                handler: async () => {
                  let text = `[${location.origin}/a/${this.user.url_slug}] 你好，举报此创作者，理由为`;
                  this.$modal.hide('dialog');
                  this.$router.push(`/message/27f7cea2370d11e8ae8852540025c377?is_keyboard_up=1&text=${text}`);
                },
            },
            ],
        });
    },
    block(){
        this.close_more();
        if(this.user.is_block == 1){
            this.action('block','cancel')
            return false;
        }
        this.$modal.show('dialog', {
           title: this.$t('c.dialog.text5'),
            text:`<div class="black-8 fs12" style="word-break: break-all">
                    <p>你们双方将看不到对方的评论和电圈帖子</p>
                </div>`,
            buttons: [
                {
                    title: this.$t('c.dialog.text1'),
                    handler: () => {
                    this.$modal.hide('dialog');
                    },
                },
                {
                    title: this.$t('c.dialog.text2'),
                    handler: async () => {
                        this.action('block')
                        this.$modal.hide('dialog');
                    },
                },
            ],
        });
    },
    reject(){
        this.close_more();
        if(this.user.is_reject == 1){
            this.action('reject','cancel')
            return false;
        }
        this.$modal.show('dialog', {
            title: this.$t('c.dialog.text4'),
            text:`<div class="black-8 fs12" style="word-break: break-all">
                    <p>无法再次向你发电</p>
                    <p>无法向你点赞、评论、私信</p>
                    <p>从你的电圈中移出该成员，并无法加入</p>
                    <p class="mt24">TA 在发电有效期内仍可以查看你的付费内容</p>
                    <p>如需取消权益，请联系管理员 <span class="purple">@Lain音酱</span></p>
                </div>`,
            buttons: [
                {
                    title: this.$t('c.dialog.text1'),
                    handler: () => {
                    this.$modal.hide('dialog');
                    },
                },
                {
                    title: this.$t('c.dialog.text2'),
                    handler: async () => {
                        this.action('reject')
                        this.$modal.hide('dialog');
                    },
                },
            ],
        });
    },
    async action(type = '', action_type = ''){
      let api = action_type == 'cancel' ? POST_API_USER_UNBLACK : POST_API_USER_BLACK;
      if (this.$http.is_run(api)){
        return false;
      }
      let data = await this.$http.$axios(api, {
          user_id:this.user.user_id,
          type,
      });

      this.$notify({
        title: data.em,
        group: data.ec == 200 ? 'success': 'error',
      });

      if(data.ec == 200){
        //   let d = this.user[`is_${type}`]
        //   this.user[`is_${type}`] = d == 1 ? 0 : 1;
        this.app_router_reload()
      }
    }

  },
};
</script>

<style lang="stylus" scoped>
.vm-black-list {
    position: relative;
    height:18px;
    .action-list{
        z-index: 1;
        border: 1px solid $black-1;
        box-sizing: border-box;
        box-shadow: $layer-shadow;
        position: absolute;
        bottom: 0px;
        right: 0;
        background:$white;
        width:150px;
        transform: translateY(105%);
        border-radius: 4px;
        .item-box{
            padding:12px 16px;
            &:active{
                background:$black-05;
            }
        }
    }
}
</style>
